import actions from '../../actionTypes';

export default siteId => {
  return {
    type: actions.GET_AP_DETAIL,
    siteId
  };
};



// WEBPACK FOOTER //
// ./src/reducers/status/actions/getApDetail.js